import { render } from "./NewAsideDataTable.vue?vue&type=template&id=5a545dc5&scoped=true"
import script from "./NewAsideDataTable.vue?vue&type=script&lang=js"
export * from "./NewAsideDataTable.vue?vue&type=script&lang=js"

import "./NewAsideDataTable.vue?vue&type=style&index=0&id=5a545dc5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a545dc5"]])

export default __exports__